import React from 'react';
import { DeliveryStatus } from '../types';
import OrderDetails from './order-details';
import { ShopifyOrder } from '../types';
import "./tracking-progress.css";

interface TrackingProgressProps {
  delivery: DeliveryStatus | null;
  status: string;
  order: ShopifyOrder;
}

const TrackingProgress: React.FC<TrackingProgressProps> = ({ delivery, status, order }) => {
  // Función para determinar el progreso de la entrega
  const getDeliveryProgress = (status: string) => {
    switch(status) {
      case "HCA": return 1; // Recolección
      case "TRN": return 2; // En tránsito
      case "HDC": return 3; // Entregado
      case "CWB": return 3; // Cancelado
      case "HDR": return 3; // Devoluciones
      case "EXL": return 3; // Excepciones
      default: return 0;
    }
  };

  // Función para determinar el texto del estado final
  const getFinalStatusText = (status: string) => {
    switch(status) {
      case "HDC": return "Entregado";
      case "CWB": return "Cancelado";
      case "HDR": return "Devoluciones";
      case "EXL": return "Excepciones";
      default: return "Entregado";
    }
  };

  return (
    <div className="tracking-container">
      <h1>Seguimiento de Envío</h1>
      
      <div className="tracking-info">
        <p>Número de rastreo: <strong>{delivery?.trackingNumber}</strong></p>
        <a 
          href={`https://www.paquetexpress.com.mx/rastreo/${delivery?.trackingNumber}`} 
          target="_blank" 
          rel="noopener noreferrer"
          className="tracking-link"
        >
          Seguimiento Paquetexpress
        </a>
      </div>

      <div className="progress-container">
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${(getDeliveryProgress(status) / 3) * 100}%` }}
          ></div>
        </div>
        
        <div className="progress-steps">
          <div className={`progress-step ${getDeliveryProgress(status) >= 1 ? 'active' : ''}`}>
            <div className="step-indicator"></div>
            <div className="step-label">Recolección</div>
          </div>
          
          <div className={`progress-step ${getDeliveryProgress(status) >= 2 ? 'active' : ''}`}>
            <div className="step-indicator"></div>
            <div className="step-label">En Tránsito</div>
          </div>
          
          <div className={`progress-step ${getDeliveryProgress(status) >= 3 ? 'active' : ''}`} data-status={status}>
            <div className="step-indicator"></div>
            <div className="step-label">{getFinalStatusText(status)}</div>
          </div>
        </div>
      </div>
      
      <div className="delivery-details">
        <OrderDetails order={order} />
      </div>
    </div>
  );
};

export default TrackingProgress; 